export class EacSvcItem {
    public name: string;
    public years: number[];

    constructor(name, fee) {
        this.name = name;
        this.years = fee;
    }
}
